import React, { useState } from 'react';

const SiteTabs = ({ Pending, Approval, Rejected, Borrowal }) => {
  const [activeTab, setActiveTab] = useState('pending');

  return (
    <div className="w-full">
      {/* Tab headers */}
      <div className="flex items-center justify-between px-[35px] h-full">
        <div className="flex gap-6 text-gray-600 text-lg">
          <button
            onClick={() => setActiveTab('pending')}
            className={`transition-colors ${
              activeTab === 'pending'
                ? 'text-blue-600 font-bold border-b-2 border-blue-600 pb-1'
                : ''
            }`}
          >
            Pending
          </button>

          <button
            onClick={() => setActiveTab('approved')}
            className={`transition-colors ${
              activeTab === 'approved'
                ? 'text-blue-600 font-bold border-b-2 border-blue-600 pb-1'
                : ''
            }`}
          >
            Approved
          </button>

          <button
            onClick={() => setActiveTab('rejected')}
            className={`transition-colors ${
              activeTab === 'rejected'
                ? 'text-blue-600 font-bold border-b-2 border-blue-600 pb-1'
                : ''
            }`}
          >
            Rejected
          </button>

           <button
            onClick={() => setActiveTab('borrowed')}
            className={`transition-colors ${
              activeTab === 'borrowed'
                ? 'text-blue-600 font-bold border-b-2 border-blue-600 pb-1'
                : ''
            }`}
          >
           Borrowed
          </button>
        </div>
      </div>

      {/* Tab content */}
      <div className="py-2 px-[35px]">
        {activeTab === 'pending' && (
          <div>
            {Pending}
          </div>
        )}

        {activeTab === 'approved' && (
          <div>
            {Approval}
          </div>
        )}

        {activeTab === 'rejected' && (
          <div>
            {Rejected}
          </div>
        )}
        {activeTab === 'borrowed' && (
          <div>
            {Borrowal}
          </div>
        )}
      </div>
    </div>
  );
};

export default SiteTabs;
